export default "__VITE_ASSET__Bt4ZM5oz__"